import { RangeFilterDefinition } from "@/blocks/marketsuite/filters/schemas/range";
import { SelectFilterDefinition } from "@/blocks/marketsuite/filters/schemas/select";
import { TextFilterDefinition } from "@/blocks/marketsuite/filters/schemas/text";

export type FilterScope = "project" | "partner" | "property" | "search-profile";
export type FilterDefinition = SelectFilterDefinition | RangeFilterDefinition | TextFilterDefinition;

export const FILTER_TYPE_DEFINITIONS: FilterDefinition[] = [
	{
		slug: "area",
		label: "Area",
		pluralLabel: "Areas",
		dbName: "area",
		kind: "select",
		filterKey: "address.location",
		scopes: ["property", "partner", "search-profile"],
		appearances: ["select"],
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
	{
		slug: "location",
		label: "Location",
		pluralLabel: "Locations",
		dbName: "location",
		kind: "select",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox"],
		dataKey: "location",
		filterKey: "address.location",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
	{
		slug: "property-type",
		label: "Property Type",
		pluralLabel: "Property Types",
		dbName: "proptype",
		kind: "select",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox"],
		dataKey: "property-type",
		filterKey: "type",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
	{
		slug: "energy-label",
		label: "Energy Label",
		pluralLabel: "Energy Labels",
		dbName: "enerlabl",
		kind: "select",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox"],
		dataKey: "energy-label",
		filterKey: "energy_label",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
	{
		slug: "facility",
		label: "Faclity",
		pluralLabel: "Facilities",
		dbName: "facility",
		kind: "select",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox"],
		dataKey: "facility",
		filterKey: "facility",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
	{
		slug: "rooms",
		label: "Number of Rooms",
		pluralLabel: "Number of Rooms",
		dbName: "rooms",
		kind: "range",
		scopes: ["property", "search-profile"],
		appearances: ["slider", "range-text"],
		dataKey: "rooms",
		filterKey: "rooms",
		settings: {
			dynamic: { defaultValue: true },
		},
	},
	{
		slug: "bedrooms",
		label: "Number of Bedrooms",
		pluralLabel: "Number of Bedrooms",
		dbName: "bedrooms",
		kind: "range",
		scopes: ["property", "search-profile"],
		appearances: ["slider", "range-text"],
		dataKey: "bedrooms",
		filterKey: "bedrooms",
		settings: {
			dynamic: { defaultValue: true },
		},
	},
	{
		slug: "subtype",
		label: "Subtype",
		pluralLabel: "Subtypes",
		dbName: "subtype",
		kind: "select",
		dataKey: "subtype",
		filterKey: "subtype",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox", "toggleGroup"],
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: false },
		},
	},
	{
		slug: "district",
		label: "District",
		pluralLabel: "Districts",
		dbName: "neighborhood",
		kind: "select",
		dataKey: "neighborhood",
		filterKey: "address.district",
		scopes: ["property", "partner", "search-profile"],
		appearances: ["select", "checkbox", "toggleGroup"],
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: false },
		},
	},
	{
		slug: "status",
		label: "Status",
		pluralLabel: "Statuses",
		dbName: "status",
		kind: "select",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox", "toggleGroup"],
		dataKey: "status",
		filterKey: "status",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: false },
		},
	},
	{
		slug: "construction-type",
		label: "Construction Type",
		pluralLabel: "Construction Types",
		dbName: "constrtype",
		kind: "select",
		dataKey: "construction-type",
		filterKey: "construction_type",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox", "toggleGroup"],
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: false },
		},
	},
	{
		slug: "building",
		label: "Building",
		pluralLabel: "Buildings",
		dbName: "building",
		kind: "select",
		filterKey: "building",
		scopes: ["property", "search-profile"],
		appearances: ["select", "checkbox", "toggleGroup"],
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: false },
		},
	},
	{
		slug: "partner",
		label: "Partner",
		pluralLabel: "Partners",
		dbName: "partner",
		kind: "select",
		scopes: ["property"],
		appearances: ["select", "checkbox"],
		dataKey: "partner",
		filterKey: "partner.id",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
	{
		slug: "price",
		label: "Price",
		pluralLabel: "Prices",
		dbName: "price",
		kind: "range",
		scopes: ["property", "search-profile"],
		appearances: ["slider", "range-text"],
		dataKey: "price",
		filterKey: "price",
		settings: {
			dynamic: { defaultValue: true },
		},
	},
	{
		slug: "living-area",
		label: "Living Area",
		pluralLabel: "Living Areas",
		dbName: "livingArea",
		kind: "range",
		scopes: ["property", "search-profile"],
		appearances: ["slider", "range-text"],
		dataKey: "living-area",
		filterKey: "living_area",
		settings: {
			dynamic: { defaultValue: true },
		},
	},
	{
		slug: "partner-name",
		label: "Partner Name",
		pluralLabel: "Partner Names",
		dbName: "partnerName",
		kind: "text",
		filterKey: "name",
		scopes: ["partner"],
	},
	{
		slug: "partner-child-name",
		label: "Partner Child Name",
		pluralLabel: "Partner Child Names",
		dbName: "partnerName",
		kind: "text",
		filterKey: "children.name",
		scopes: ["partner"],
	},
	{
		slug: "tags",
		label: "Tags",
		pluralLabel: "Tags",
		dbName: "tags",
		kind: "select",
		scopes: ["partner"],
		appearances: ["select", "checkbox"],
		filterKey: "tag",
		settings: {
			dynamic: { defaultValue: true },
			multiple: { defaultValue: true },
		},
	},
];
